import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SearchPanel from "@widgets/SearchPanel";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_BAS_REG_002_POP_01 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });

    const [popupParent, setPopupParent] = useState<any>(null);
    const [initFlag, setInitFlag] = useState<boolean>(false);
    const [doubleData, setDoubleData] = useState<any[]>();

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let lsChk: any = "2";
        const checkedRows =
          doubleData && doubleData.length > 0
            ? doubleData
            : gridRefs.current["grid1"].current?.getCheckedRows() || [];
        for (const row of checkedRows) {
          if (row?.um === "" || row?.um === null || row?.um === undefined) {
            lsChk = "1";
            break;
          } else {
            lsChk = "2";
          }
        }
        if (lsChk === "1") {
          const confirm = await showDialog(
            "confirm",
            "단가 정보가 누락되었습니다. 진행하시겠습니까?"
          );
          if (!confirm) return { flag: false };
        }
        return { flag: true };
      },
      getSelectedRow: () => {
        if (doubleData && doubleData.length > 0) {
          return [doubleData];
        }

        return [gridRefs.current["grid1"].current?.getCheckedRows() || []];
      },
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SAL_BAS_REG_002_POP_01",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          setInitFlag(true);
        } catch (error) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      if (initFlag) onSearch();
    }, [initFlag]);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_sal_bas_reg_002_pop_01",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_cust: formData.cd_cust,
            cd_cust_rcv: searchRef.current.getFormdata().cd_cust_rcv,
          },
        };

        gridRefs.current["grid1"].current.resetUpdate();
        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
        });

        if (!data[0] || data[0].length === 0) {
          await showDialog("alter", "신규품목이 없습니다.");
        }
      } catch (error: any) {}
    };

    const onCellValueChanged = (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;

      if (colId === "um") {
        const um_supply = +(rowData.um * 1.1);
        rowNode.setDataValue("um_supply", um_supply, "noEvent");
      }
      if (colId === "um_supply") {
        const um = +((rowData.um_supply * 10) / 11);
        rowNode.setDataValue("um", um, "noEvent");
      }
    };

    const onCellDoubleClicked = (e: any) => {
      console.log(e);
      let returnData: any[] =
        gridRefs.current["grid1"].current?.getCheckedRows();
      const exists = returnData.some((data) => data.cd_item === e.data.cd_item);
      if (!exists) returnData.push(e.data);
      setDoubleData(returnData);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onCellValueChanged: onCellValueChanged,
            onCellDoubleClicked: onCellDoubleClicked,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "multiple",
              ischeckboxSelection: true,
              popupParent: popupParent,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_SAL_BAS_REG_002_POP_01;
